import React from 'react';
import { Link } from "react-router-dom";

class ProductNav extends React.Component{

    render(){
        return (
                <div className="text-center product-nav">
                    <div className="prodtop">
                        <div style={{"height": "1rem"}}></div>
                        <Link to={{pathname:'/'}}>
                        <h3 className="prodtopcapt">Products</h3>
                        </Link>
                    </div>
                    {/* <div className="prodtopcat">
                        <h5 className="prodtopcapt">Bulk Bag Processing</h5>
                    </div> */}
                    <div className="prodcat">
                    <Link to={{pathname:"/BulkBagFill"}}>
                        <div className="grey">Bulk Bag Fillers</div>
                    </Link>
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/BulkBagDischarge"}}>
                        <div className="grey">Bulk Bag Dischargers</div>
                    </Link>
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/BulkBagCondition"}}>
                        <div className="grey">Bulk Bag Conditioners</div>
                    </Link>
                    </div>
                    {/* <div className="prodtopcat">
                        <h5 className="prodtopcapt">Feeders and Scales</h5>
                    </div> */}
                    <div className="prodcat">
                    <Link to={{pathname:"/BeltScales"}}>
                        <div className="grey">Belt Scales</div>
                    </Link> 
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/BeltFeeders"}}>
                        <div className="grey">Weigh Belt Feeders</div>
                    </Link> 
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/VolumetricFeeders"}}>
                        <div className="grey">Volumetric Feeders</div>
                    </Link> 
                    </div>                                                         
                    <div className="prodcat">
                    <Link to={{pathname:"/AirClassifiers"}}>
                        <div className="grey">Air Classifiers</div> 
                    </Link> 
                    </div> 
                    {/* <div className="prodtopcat">
                        <h5 className="prodtopcapt">Material Processing</h5>
                    </div>                    */}
                    {/* <div className="prodcat">
                    <Link to={{pathname:"/AirClassifyingMills"}}>
                        <div className="grey">Air Classifying Mills</div>
                    </Link> 
                    </div>                     */}
                    <div className="prodcat">
                    <Link to={{pathname:"/HammerMills"}}>
                        <div className="grey">Hammer Mills</div>
                    </Link> 
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/MegaMills"}}>
                        <div className="grey">Mega Mills</div> 
                    </Link> 
                    </div>                    
                    <div className="prodcat">
                    <Link to={{pathname:"/FineGrinder"}}>
                        <div className="grey">Fine Grinding Mills</div>
                    </Link> 
                    </div>                    
                    <div className="prodcat">
                    <Link to={{pathname:"/LumpFlakeBreaker"}}>
                        <div className="grey">Lump/Flake Breakers</div>
                    </Link> 
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/CentrifugalSifter"}}>
                        <div className="grey">Centrifugal Sifters</div>
                    </Link> 
                    </div>
                    {/* <div className="prodtopcat">
                        <h5 className="prodtopcapt">Air Locks</h5>
                    </div> */}
                    <div className="prodcat">
                    <Link to={{pathname:"/AirLock"}}>
                        <div className="grey">Air Lock- HS Series</div>
                    </Link> 
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/PressureBlower"}}>
                        <div className="grey">Pressure Blowers</div>
                    </Link> 
                    </div>                    
                    <div className="prodcat">
                    <Link to={{pathname:"/VentFilterSFTC"}}>
                        <div className="grey">Vent Filters- SFTC Series</div>
                    </Link> 
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/VentFilterSFT"}}>
                        <div className="grey">Vent Filter- SFT Series</div>
                    </Link> 
                    </div>
                    <div className="prodcat">
                    <Link to={{pathname:"/FilterReceiver"}}>
                        <div className="grey">Filter Receivers</div>
                    </Link> 
                    </div>                   
                    <div className="prodcat">
                    <Link to={{pathname:"/ProductSeperator"}}>
                        <div className="grey">Horizontal Product Seperators</div>
                    </Link> 
                    </div>                    
                    <div className="prodcat">
                    <Link to={{pathname:"/Sidewinder"}}>
                        <div className="grey">Insertable Sindewinders</div>
                    </Link> 
                    </div>                    
                </div>
        )
    }
}

export default ProductNav;